export enum InconsistencyType {
  MissingPeer = 'missing-peer',
  MissingProducer = 'missing-producer',
  IncorrectProducerState = 'incorrect-producer-state',
  IncorrectConsumerState = 'incorrect-consumer-state',
  IncorrectAppData = 'incorrect-app-data',
}

export type StorageKey = 'missingPeers'
| 'missingProducers'
| 'consumersWithInconsistentState'
| 'producersWithInconsistentState'
| 'peersWithInconsistentAppData';

export interface ChannelStateConsistencyCheckResultsParams {
  missingPeers: string[];
  missingProducers: string[];
  consumersWithInconsistentState: string[];
  producersWithInconsistentState: string[];
  peersWithInconsistentAppData: string[];
}
